import { Enumify } from 'enumify-ts';
class CommunicationPurpose extends Enumify() {
    description;
    driverRelated;
    static API_KEY = new CommunicationPurpose("Api Key", false);
    static CONTRACTOR_REGISTRATION_CONFIRMATION = new CommunicationPurpose("Contractor Registration Confirmation", false);
    static CONTRACTOR_REGISTRATION_OTP = new CommunicationPurpose("Contractor One Time Password", false);
    static CONTRACTOR_REGISTRATION_NOTIFICATION = new CommunicationPurpose("Contractor Registration Notification", false);
    static CARRIER_DELIVERIES = new CommunicationPurpose("Carrier Deliveries Complete", false);
    static DELIVERY_COMPLETE = new CommunicationPurpose("Delivery Complete", false);
    static DELIVERY_PROOF = new CommunicationPurpose("Proof of Delivery", false);
    static DELIVERY_SCHEDULED = new CommunicationPurpose("Delivery Scheduled", false);
    static DELIVERY_STARTED = new CommunicationPurpose("Delivery Started", false);
    static DRIVER_START_TIME = new CommunicationPurpose("Driver Start Time", true);
    static DRIVER_IDLE = new CommunicationPurpose("Driver Idle", true);
    static DRIVER_NOTIFICATION = new CommunicationPurpose("Driver Notification", true);
    static DRIVER_SCHEDULE_PERFORMANCE = new CommunicationPurpose("Driver Schedule Performance", true);
    static DRIVER_COMPLETE_REMINDER = new CommunicationPurpose("Driver Complete Reminder", true);
    static DRIVER_CUSTOMER_MESSAGE = new CommunicationPurpose("Driver Customer Message", true);
    static DRIVER_FATIGUE_MAX_HOURS = new CommunicationPurpose("Driver Fatigue Max Hours Breached", true);
    static DRIVER_FATIGUE_MAX_WORK_EXCEEDED_SOON = new CommunicationPurpose("Driver Maximum Work Exceeded Soon", true);
    static DRIVER_FATIGUE_BREAK_OVERDUE = new CommunicationPurpose("Driver Fatigue Break Overdue", true);
    static DRIVER_FATIGUE_BREAK_DUE_SOON = new CommunicationPurpose("Driver Fatigue Break Due Soon", true);
    static DRIVER_NOT_REPORTING_LOCATION = new CommunicationPurpose("Driver is Not Reporting Location", true);
    static DRIVER_DEVICE_TIME_ABNORMAL = new CommunicationPurpose("Driver Device Time is Abnormal", true);
    static END_OF_DAY_FEEDBACK = new CommunicationPurpose("End of day Feedback", false);
    static EXPIRING_LICENSE_INSURANCE = new CommunicationPurpose("Expiring License or Insurance", false);
    static EXPIRING_DRIVER_LICENSE = new CommunicationPurpose("Expiring Driver License", false);
    static EXPIRING_VEHICLE_REGISTRATION = new CommunicationPurpose("Expiring Vehicle Registration", false);
    static EXPIRING_INSURANCE_POLICY = new CommunicationPurpose("Expiring Insurance Policy", false);
    static HIRED_CONTRACTOR_START_TIME = new CommunicationPurpose("Hired Contractor Start Time", false);
    static LOW_CREDIT_WARNING = new CommunicationPurpose("Low Credit Warning", false);
    static PASSWORD_RESET = new CommunicationPurpose("Password Reset", false);
    static VEHICLE_CHECK_FAILED = new CommunicationPurpose("Checklist Failed", false);
    static WELCOME = new CommunicationPurpose("Welcome", false);
    static CONSIGNMENT_DUE = new CommunicationPurpose("Delivery Due", false);
    static CONSIGNMENT_DRIVER_UNASSIGNED = new CommunicationPurpose("Delivery Driver Unassigned", false);
    static VEHICLE_HIRE_ACCEPTED = new CommunicationPurpose("Vehicle Request Accepted", false);
    static VEHICLE_HIRE_DEALLOCATED = new CommunicationPurpose("Vehicle Request Deallocated", false);
    static VEHICLE_HIRE_NOT_STARTED = new CommunicationPurpose("Vehicle Request Not Started", false);
    static VEHICLE_HIRE_NOT_COMPLETED = new CommunicationPurpose("Vehicle Request Not Completed", false);
    static TENANT_REGISTRATION = new CommunicationPurpose("Profile Registration", false);
    static BANK_DETAILS_CHANGED = new CommunicationPurpose("Bank Details Changed", false);
    static VEHICLE_RATES_ANOMALY = new CommunicationPurpose("Vehicle Rate Anomaly", false);
    static TENANT_REGISTRATION_SUMMARY_LIST = new CommunicationPurpose("Tenant Registration Summary", false);
    static MARKETPLACE_CONSIGNMENT_ACCEPTED = new CommunicationPurpose("Marketplace Delivery Accepted", false);
    static MARKETPLACE_PROFFER_JOB = new CommunicationPurpose("Marketplace Job Offer", false);
    static MARKETPLACE_NO_CONTRACTOR_AVAILABLE = new CommunicationPurpose("Marketplace No Cotnractor Available", false);
    static ACCOUNTS_ATTACHMENT_FAILED = new CommunicationPurpose("Accounts Attachment Failed", false);
    static REFERRAL = new CommunicationPurpose("Referral", false);
    static RETAIL_EXPRESS_FAILED_ORDER = new CommunicationPurpose("Retail Express Order Failed", false);
    static SCHEDULED_VEHICLE_HIRE_FAILURE = new CommunicationPurpose("Failed to Create Vehicle Request from Schedule", false);
    static SALES_ORDER_QUOTE = new CommunicationPurpose("Sales Order Quote", false);
    static _ = CommunicationPurpose._closeEnum();
    constructor(description, driverRelated) {
        super();
        this.description = description;
        this.driverRelated = driverRelated;
    }
    static driverRelatedFiltersArray() {
        return CommunicationPurpose.values.filter(t => t.driverRelated).map(t => {
            return { text: t.description, value: t.key };
        });
    }
}
export default CommunicationPurpose;
